import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceOverview } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useLoaderData();
	
	return (
		<WorkspaceOverview
			workspaceId={workspaceId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}